import { ScreenAuthPassword } from '@dms/screen'

export default ScreenAuthPassword
